import gql from 'graphql-tag'
import client from '@stores/apollo'
import { SpaceTypeFragment } from '@api/fragments'

export default function create(id: string) {
  return client.gql.mutate({ mutation, variables: { input: { id } } })
}

const mutation = gql`
  mutation deleteSpaceType($input: DeleteSpaceTypeInput!) {
    deleteSpaceType(input: $input) {
      spaceType {
        ...SpaceTypeFragment
      }
    }
  }
  ${SpaceTypeFragment}
`
